import { defineComponent as D, computed as R, openBlock as v, createElementBlock as y, renderSlot as p, normalizeProps as g, guardReactiveProps as _, createTextVNode as x, toDisplayString as h, Fragment as T, renderList as A, mergeProps as E, createElementVNode as C } from "vue";
const w = Number.MAX_SAFE_INTEGER, L = {
  CHAR: "",
  WORD: "(\\s)",
  LINE: "(\\n)"
}, S = L.CHAR, B = (i, t) => {
  const a = [];
  for (let s = 0; s <= i.length; s++) {
    a[s] = [];
    for (let o = 0; o <= t.length; o++)
      s === 0 ? a[s][o] = o : o === 0 ? a[s][o] = s : a[s][o] = 0;
  }
  return a;
}, k = (i, t, a) => a ? (i == null ? void 0 : i.toLowerCase()) === (t == null ? void 0 : t.toLowerCase()) : i === t, M = (i, t, a) => {
  let s, o, n;
  const e = B(i, t);
  for (let l = 1; l <= i.length; l++)
    for (let r = 1; r <= t.length; r++)
      s = e[l][r - 1], o = e[l - 1][r - 1], n = e[l - 1][r], k(i[l - 1], t[r - 1], a) ? e[l][r] = o : e[l][r] = Math.min(s, o, n) + 1;
  return e;
}, N = (i, t, a, s) => {
  const o = [];
  let n = i.length, e = t.length, l, r, u, c, d = "", m = "", f;
  for (; n > 0 || e > 0; ) {
    if (k(i[n - 1], t[e - 1], s))
      d = t[e - 1], f = "equal", n--, e--;
    else if (n - 1 < 0 ? u = w : u = a[n - 1][e], e - 1 < 0 ? l = w : l = a[n][e - 1], n - 1 < 0 || e - 1 < 0 ? r = w : r = a[n - 1][e - 1], c = Math.min(l, u, r), c === l)
      d = t[e - 1], f = "add", e--;
    else if (c === u)
      d = i[n - 1], f = "delete", n--;
    else if (c === r)
      d = i[n - 1], f = "replace", m = t[e - 1], n--, e--;
    else
      throw new Error("Invalid source");
    f === "replace" ? o.push({ char: d, type: f, replacedBy: m }) : o.push({ char: d, type: f });
  }
  return o.reverse();
}, I = (i, t, a = {}) => {
  const { splitBy: s = S, ignoreCase: o = !1 } = a, n = i.match(new RegExp(s)), e = n ? n.shift() : "", l = i.split(new RegExp(s, "g")), r = t.split(new RegExp(s, "g")), u = M(l, r, o), c = N(l, r, u, o);
  return {
    from: l,
    to: r,
    diffs: c,
    distance: u[l.length][r.length],
    splitter: e
  };
}, $ = {
  key: 0,
  class: "vue-diff"
}, q = {
  key: 1,
  class: "vue-diff"
}, V = /* @__PURE__ */ D({
  __name: "VueDiff",
  props: {
    text: { default: void 0 },
    newText: {},
    includeDeletions: { type: Boolean, default: !1 },
    ignoreCase: { type: Boolean, default: !1 }
  },
  setup(i) {
    const t = i, a = R(() => t.text === void 0 ? [] : I(t.text, t.newText, { ignoreCase: t.ignoreCase }).diffs.filter((s) => s.type === "delete" ? t.includeDeletions : !0));
    return (s, o) => t.text === void 0 ? (v(), y("span", $, [
      p(s.$slots, "equal", g(_({ value: t.newText })), () => [
        x(h(t.newText), 1)
      ])
    ])) : (v(), y("span", q, [
      (v(!0), y(T, null, A(a.value, ({ type: n, char: e, replacedBy: l }, r) => (v(), y(T, { key: r }, [
        n === "add" ? p(s.$slots, "insert", g(E({ key: 0 }, { value: e })), () => [
          C("ins", null, h(e), 1)
        ]) : n === "delete" ? p(s.$slots, "delete", g(E({ key: 1 }, { value: e })), () => [
          C("del", null, h(e), 1)
        ]) : n === "replace" ? p(s.$slots, "replace", g(E({ key: 2 }, { value: l, replacedChar: e })), () => [
          C("ins", null, h(l), 1)
        ]) : p(s.$slots, "equal", g(E({ key: 3 }, { value: e })), () => [
          x(h(e), 1)
        ])
      ], 64))), 128))
    ]));
  }
});
export {
  V as VueDiff
};
